<template>
  <Map :userAdmin="userAdmin" :userLogin="userLogin" />
</template>

<script>
import Map from '../components/Map.vue';

export default {
  name: 'MapView',
  props: {
    userAdmin: {
      type: Boolean
    },
    userLogin: {
      type: Boolean
    }
  },
  components: {
    Map
  }
};
</script>
